import './Toaster.scss';
import React from 'react';
import PropTypes from 'prop-types';

class FailedToaster extends React.Component {
  static propTypes = {
    dismissText: PropTypes.string,
    onDismiss: PropTypes.func,
    text: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool,
  };

  static defaultProps = {
    isAdmin: false,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  renderActionBar() {
    const { onDismiss, dismissText, isAdmin } = this.props;
    const { getString } = this.context;

    if (!onDismiss) {
      return null;
    }

    return (
      <div className="toaster-action">
        {!isAdmin
          && (
            <a className="btn btn-link" href="/help">
              <span>{getString('AA_Contact_Us')}</span>
            </a>
          )
        }
        <a className="btn btn-link" onClick={onDismiss}>
          <span>{dismissText || getString('AA_OK')}</span>
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="toaster-wrapper">
        <div className="toaster-background" onClick={this.props.onDismiss} />
        <div className="toaster">
          <div className="toaster-content">
            <div className="toaster-icon">
              <span className="glyphicon glyphicon-remove" aria-hidden="true" />
            </div>
            <span className="toaster-text" aria-live="polite" dangerouslySetInnerHTML={{ __html: this.props.text }} />
          </div>
          {this.renderActionBar()}
        </div>
      </div>
    );
  }
}

export default FailedToaster;
